module.exports = __webpack_public_path__ + "img/W-as1.8c09b9ae.jpg";